export function getAnswerSharePath(token: string): string {
  return `/forms/answers/${encodeURIComponent(token)}`;
}

export function getAnswerShareUrl(token: string): string {
  if (typeof window !== "undefined") {
    return `${window.location.origin}${getAnswerSharePath(token)}`;
  }
  return getAnswerSharePath(token);
}
